import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AdminLayoutService } from '../admin-layout/admin-layout.service';

declare var $: any;
declare var DevExpress: any;

@Component({
  selector: 'app-report-layout',
  templateUrl: './report-layout.component.html'
})
export class ReportLayoutComponent implements OnInit {
  currentUser: any = {};
  constructor(
    private service: AdminLayoutService) { 
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    }

  ngOnInit(): void {
    // this.service.getSource();
    this.service.connectSignalR();
  }
}
